import { lazy, Suspense } from 'react';
import { useBuilderOverlay } from './store/builderOverlayStore';
import { BuilderSkeleton } from './components/BuilderSkeleton/BuilderSkeleton';
import type { BuilderApiAdapter } from './types/api.types';

const DesignBuilder = lazy(() =>
  import('./DesignBuilder').then((m) => ({ default: m.DesignBuilder })),
);

interface BuilderOverlayProps {
  api: BuilderApiAdapter;
  manageLibraryUrl?: string;
}

export const BuilderOverlay = ({ api, manageLibraryUrl }: BuilderOverlayProps) => {
  const { isOpen, productId, designId, productSlug, onSaveCallback, closeBuilder } =
    useBuilderOverlay();

  if (!isOpen) return null;

  return (
    <Suspense fallback={<BuilderSkeleton productSlug={productSlug ?? undefined} />}>
      <DesignBuilder
        api={api}
        productId={productId ?? undefined}
        designId={designId ?? undefined}
        productSlug={productSlug ?? undefined}
        manageLibraryUrl={manageLibraryUrl}
        onSave={(id) => {
          onSaveCallback?.(id);
          closeBuilder();
        }}
        onClose={closeBuilder}
      />
    </Suspense>
  );
};
